import React, {Component, Fragment} from "react";
import PlayerReport from "../../../../ui/tabs/scouting_reports_tab_base/PlayerReport";
import {Col, Container, Image, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import VideosPerMatchModal from "../../full_profile/modals/VideosPerMatchModal";
import Icon, {bolt, brain, bullsEyeArrow, handRock, running, shield, star} from "../../../../ui/Icon";
import HorizontalTabs from "../../../../ui/tabs/HorizontalTabs";
import PlayerAbilityCard from "../../../../ui/cards/PlayerAbilityCard";

const items = [
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [{name: 'Adel', type: 'pdf'}]},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
];

const playerAbilities = [
    {title: 'Attacking', icon: bullsEyeArrow, items: items},
    {title: 'Skills', icon: handRock, items: items},
    {title: 'Movement', icon: running, items: items},
    {title: 'Power', icon: bolt, items: items},
    {title: 'bolt', icon: brain, items: items},
    {title: 'Defence', icon: shield, items: items},
    {title: 'Goal Keeping', icon: bolt, items: items},
    {title: 'Specialities', icon: star, items: items},
];

class ScoutingPlayerReport extends PlayerReport {

    /**
     * Renders the body content of the player report.
     * @returns {React.ReactNode} The body content.
     */
    renderContent = () => {

        const items = playerAbilities.map((playerAbility, index) =>
            HorizontalTabs.createItem(<Icon className="black" svg={playerAbility.icon}/>,
                <ScoutingPlayerReport.PlayerAbility title={playerAbility.title} icon={playerAbility.icon} items={playerAbility.items} scrollable={true} onAttachmentClick={() => this.setModalShow(VideosPerMatchModal.Name, true)}/>
            )
        );

        return (
            <Container fluid={true} className="d-flex flex-column flex-grow-1">
                <Row className="overview report-row">
                    <Col lg="2" xs="6">
                        <PlayerReport.InfoCard title="Over All Score" description="83"/>
                    </Col>
                    <Col lg="10" xs="6">
                        <PlayerReport.InfoCard title="Over All Evaluation Comment" description="Dustin is the calm player and has a good control over the ball and mind, Good Passing and Shooting skills"/>
                    </Col>
                </Row>
                <Row className="report-row justify-content-between">
                    <Col>
                        <div className="text-header">
                            <span>Evaluation Scores</span>
                            <Link to="/scouting/evaluation-report">View Full Report</Link>
                        </div>
                    </Col>
                </Row>
                <Row className="report-row flex-grow-1">
                    <HorizontalTabs items={items}/>
                </Row>
            </Container>
        );
    };

    /**
     * Renders the report of the player.
     * @returns {React.ReactNode} The player report.
     */
    render = () => {
        return (
            this.wrapWithinScrollbar(
                <div className="player-report">
                    {this.renderReportHeader()}
                    {this.renderContent()}
                    {this.renderModals()}
                </div>
            )
        );
    };

    /**
     * Renders the header of the player report.
     * @returns {React.ReactNode} The report header.
     */
    renderReportHeader = () => {
        const {name, teamName, avatar} = this.props;

        return (
            <div className="report-header">
                <div className="d-flex">
                    <Image className="avatar" src={avatar} roundedCircle={true}/>
                    <div className="information">
                        <div className="name"> {name} </div>
                        <div className="d-flex">
                            <div className="team"> {teamName} </div>
                            <Link to="/scouting/full-profile" className="more-info"> See Full Profile </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

ScoutingPlayerReport.PlayerAbility = PlayerAbilityCard;

export default ScoutingPlayerReport;
